import { Heading, Text } from "@chakra-ui/react";
import React from "react";
import resume from "../data/Mohammad-Sahil-Resume.pdf";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";

import Typewriter from "typewriter-effect";
import profile from "../assets/profile-pic6.png";
import profile2 from "../assets/profile-pic.png";
import profile3 from "../assets/profile-3.jpeg";
import SocialMediaIcons from "../components/SocialMediaIcons";
import "./Home.css";
const Home = ({ useMediaQuery }) => {
  const handleClick = () => {
    window.open(
      "https://drive.google.com/file/d/1FiQ1r6UwMpjKDd-djyWRNohQzvqjqPXl/view?usp=sharing"
    );
  };

  return (
    <div id="home" className="top_Heading">
      <div>
        <Heading as={'h1'} className="h1-0"  >Hi, My name is</Heading>
        <Heading as={'h1'}   className="h1-0"  id="user-detail-name"> Mohammad Sahil</Heading>
        <Heading as={'h1'}  className="h1-0" >And I'm a Full Stack Web Developer</Heading>
        {/* <SocialMediaIcons /> */}
        <div className="resume flex justify-center md:justify-start">
          <a
            id="resume-link-2"
            class="resume_button"
            href={resume}
            download="Mohammad-Sahil-Resume.pdf"
          
          >
            <button  onClick={handleClick} className="bg-yellow p-2 mt-8   rounded" id="resume-button-2">
              Resume
            </button>
          </a>
        </div>
      </div>
      <div>
        <img
          className="home-img"
        
          
          src={profile3}
          alt="profile pic"
        />
      </div>
    </div>
  );
};

export default Home;
